import React from 'react';
import { createUseStyles } from 'react-jss';
import { useSelector } from 'react-redux';
import {
  Button,
  DownloadIcon,
  Strong, Table, Text,
} from 'evergreen-ui';
import SuspenseSpinner from 'Utils/SuspenseSpinner';
import { VirtualList } from 'Utils/VirtualList';
import { filesUrls, useGetFilesQuery } from 'Services/api/filesApi';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import { timeZoneSelector } from 'Features/App/appSlice';
import { useVirtualListTableStyles } from 'styles/useStyles';

const useStyles = createUseStyles({
  filesWrapper: {
    display: 'grid',
    gridTemplateRows: '1fr',
    padding: '.5em',
    gridRowGap: '.5em',
  },
});

export default function FileViewer() {
  const classes = useStyles();
  const tableClasses = useVirtualListTableStyles();

  const {
    data: { mappedData: files = [] } = {}, isFetching,
  } = useGetFilesQuery(filesUrls?.user?.getFiles, { refetchOnMountOrArgChange: true });
  const selectedZone = useSelector(timeZoneSelector);
  const RowTable = React.useCallback(({
    fileName, dateTime, description, id,
  }) => (
    <Table.Row isSelectable>
      <Table.Cell><Text>{dateTime ? UTCtoTimeZone(dateTime, selectedZone.selectedUserTimeZone) : ''}</Text></Table.Cell>
      <Table.Cell><Text>{fileName}</Text></Table.Cell>
      <Table.Cell><Text>{description}</Text></Table.Cell>
      <Table.Cell flexBasis={128} flexShrink={0} flexGrow={0}>
        <Button is="a" target="_blank" href={filesUrls.user.downloadFile(id)} appearance="minimal" iconBefore={DownloadIcon}>Скачать</Button>
      </Table.Cell>
    </Table.Row>
  ), [selectedZone.selectedUserTimeZone]);

  if (isFetching) return <SuspenseSpinner />;
  return (
    <div className={classes.filesWrapper}>
      <div className={tableClasses.tableWrapper}>
        <Table>
          <Table.Head>
            <Table.HeaderCell>
              <Strong>
                Дата создания UTC
                {selectedZone.selectedUserTimeZone}
              </Strong>
            </Table.HeaderCell>
            <Table.HeaderCell><Strong>Название файла</Strong></Table.HeaderCell>
            <Table.HeaderCell><Strong>Описание</Strong></Table.HeaderCell>
            <Table.HeaderCell flexBasis={128} flexShrink={0} flexGrow={0} />
          </Table.Head>
        </Table>
        {
          files.length
            ? <VirtualList data={files} row={RowTable} />
            : <Table.Row><Table.Cell><Text>Нет файлов</Text></Table.Cell></Table.Row>
        }
      </div>
    </div>
  );
}
